import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import bb from "billboard.js";
var moment = require('moment');
import Swal from 'sweetalert2';
import { index } from 'server/api/messagesystem/messagesystem.controller';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { CustomDateFormat } from '../main/CustomDateFormat';
import { DatePipe } from '@angular/common';
import { debounce } from 'lodash';

@Component({
    selector: 'cust-template',
    template: require('./customerTemplate.html'),
    styles: [`@media (max-width: 1600px) {.data-show .modal-content{min-height:172px}}`]
})
export class CustomerTemplateComponent implements OnInit {
    @Input('DisableClose') DisableClose: any;
    @Input('customerList1') customerList1: any;
    @Input("cValue") cValue: any;
    @Input("dValue") dvalue: any;
    @Output() SelectedCustomer = new EventEmitter();
    @Output() CustomerListRefresh = new EventEmitter();
    @Output("highlightParent1") highlightParent1: any;
    @ViewChild('OS') OS: ElementRef;
    @ViewChild('CustomerNotespopup') CustomerNotespopup: ElementRef;
    @ViewChild('cuatInfopopup') cuatInfopopup: ElementRef;
    @ViewChild('SalesHistorypopup') SalesHistorypopup: ElementRef;
    @Input('filterType') filterType: any;
    @Input('SerachValue') SerachValue: any;
    @Input('LastSelectedId') LastSelectedId: any;
    @ViewChild('expiryLedger') expiryLedger: ElementRef;
    @ViewChild('gpperlist') gpperlist: ElementRef;
    @ViewChild('holdsalesreturn') holdsalesreturn: ElementRef;
    @Output() CustomerAreadID = new EventEmitter();
    @Input('LastSelectedAreaId') LastSelectedAreaId: any;
    @Output() CustomerCityID = new EventEmitter();
    @Input('LastSelectedCityId') LastSelectedCityId: any;
    OLDLastSelectedCityId: any;
    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CustomDateFormat, DatePipe];
    dateFormat: any;
    bsConfig: any;
    custfiltervalue1: string;
    constructor(public utilityService: UtilityService, private http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public customDateFormat: CustomDateFormat, public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.dateFormat.dateInputFormat, containerClass: this.dateFormat.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.dateFormat.dateInputFormat;
    }

    modalReference: NgbModalRef;
    updateHSNReference: NgbModalRef;
    gridApiCust: any;
    gridColumnApiCust: any;
    paginationConf: any;
    customerList: any;
    customerDef1: any;
    selectedCustomerInfo: any;
    defaultColDef: any;
    d: any;
    public hotkeyList: Hotkey[];
    LastSearchText: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chknum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    overlayLoadingTemplate: any;
    public SelectedRowIndex = 0;
    AreaList:any = [];
    CityList:any = [];
    AreaID:any = [];
    CityID:any;
    ngOnInit(): void {
        $('.template-hidden-values #HiddenCustEnterEventTriggered').val(0);
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
        this.initHotkeys();
        this.filterType = "SearchCustomer";
        this.customerList = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";

        $(document).ready(function () {
            var position = $('#popup-customer-list').offset();
            var body = $('body').height();
            var foot = $('.info_detail_grey_block').height();
            var footh = $('.popup_footer_action_bar').height();
            if (position && position.top)
                var appHeight = body - position.top - foot - footh - 40 + 'px !important';
            $('#popup-customer-list').attr('style', 'height:' + appHeight);
        });


        this.orderSearch = {};
        this.orderSearch.filtertype = 'C';
        this.orderSearch.From_Date = this.oneMonthAgo();
        this.orderSearch.To_Date = new Date();

        this.ledgerSearch = {};
        this.ledgerSearch.filtertype = 'C';
        this.ledgerSearch.From_Date = this.oneMonthAgo();
        this.ledgerSearch.To_Date = new Date();
        this.OLDLastSelectedCityId = this.LastSelectedCityId;
        this.AreaList =[];
        this.CityList =[];
        this.getAreaList();
        this.getCityList();
    }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg,
            timer: 3000
        });
    }

    initHotkeys() {
        this.hotkeyList = [];
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Code"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="SearchCustomer"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const alta = new Hotkey('alt+a', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="altCode"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alta);
        this.hotkeysService.add(alta);

        const altB = new Hotkey('alt+b', (event: KeyboardEvent): boolean => {
            this.outstandingClick();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altB);
        this.hotkeysService.add(altB);

        const altw = new Hotkey('alt+w', (event: KeyboardEvent): boolean => {
            this.movepopup(this);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altw);
        this.hotkeysService.add(altw);

        const altu = new Hotkey('alt+u', (event: KeyboardEvent): boolean => {
            this.OpenCustomerNotesPopup();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altu);
        this.hotkeysService.add(altu);

        const alth = new Hotkey('alt+h', (event: KeyboardEvent): boolean => {
            this.OpenSalesHistoryPopup(this.SalesHistorypopup);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alth);
        this.hotkeysService.add(alth);

/*         const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc); */

        const shifte = new Hotkey('shift+e', (event: KeyboardEvent): boolean => {
            this.expiryLedgerModal(this.expiryLedger);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(shifte);
        this.hotkeysService.add(shifte);

        const shiftg = new Hotkey('shift+g', (event: KeyboardEvent): boolean => {
            this.getGPDetailsForCustomer();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(shiftg);
        this.hotkeysService.add(shiftg);

        const shifth = new Hotkey('shift+h', (event: KeyboardEvent): boolean => {
            this.getHoldSalesReturnList();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(shifth);
        this.hotkeysService.add(shifth);

        const shiftf = new Hotkey('shift+f', (event: KeyboardEvent): boolean => {
            $("input[name=custfiltervalue]").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(shiftf);
        this.hotkeysService.add(shiftf);

        const altq= new Hotkey('alt+q', (event: KeyboardEvent): boolean => {
            $('#Customer_AreaID input[role=combobox]').focus().select();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altq);
        this.hotkeysService.add(altq);

        const alty = new Hotkey('alt+y', (event: KeyboardEvent): boolean => {

            $('#Customer_CityID input[role=combobox]').focus().select();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alty);
        this.hotkeysService.add(alty);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    onGridReadyCust(params) {
        var parent = this;
        $("#filter-text-box").keypress(function (event) {
            if (event.keyCode == 13) {
                parent.custSelectionMain(parent);
            }
        });

        $(".radio-label").change(function () {
            var select = $(this).val();
            $("input#filter-text-box").val("");
            parent.gridApiCust.setFilterModel(null);
            parent.gridApiCust.onFilterChanged();
            if (select == 'Customer_Code') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Code (Ctrl+f)").blur();
            } else if (select == 'SearchCustomer') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Name (Ctrl+f)").blur();
            } else if (select == 'altCode') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By AltCode (Ctrl+f)").blur();
            }
            setTimeout(() => {
                $('#filter-text-box').focus();
            }, 200);
        });

        if (!this.filterType) {
            this.filterType = "SearchCustomer";
        }
        $(document).ready(function () {
            if (parent.filterType == 'Customer_Code') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Code (Ctrl+f)").blur();
            } else if (parent.filterType == 'SearchCustomer') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Name (Ctrl+f)").blur();
            } else if (parent.filterType == 'altCode') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By AltCode (Ctrl+f)").blur();
            }
            setTimeout(() => {
                $('#filter-text-box').focus();
            }, 200);
        });

        this.customerDef1 = [
            { headerName: 'SearchFilterValue', field: 'SearchFilterValue', width: 120, hide: true},
            { headerName: 'Code', field: 'Customer_Code', width: 120 },
            { headerName: 'Alt Code', field: 'altCode', width: 120 },
            { headerName: 'Customer Name', field: 'Customer_LegalName', width: 280 },
            { headerName: 'Customer Name', field: 'SearchCustomer', hide: true },
            { headerName: 'Address', field: 'Customer_Address1', width: 340 },
            { headerName: 'Contact', field: 'Customer_Mobile', width: 120 },
            { headerName: 'Area', field: 'Area_Name', width: 100 },
            { headerName: 'City', field: 'City_Desc', width: 100 },
            { headerName: 'State', field: 'State_Desc', width: 100 },
            { headerName: 'Email ID', field: 'Customer_EmailID', width: 90 },
            { headerName: 'Salesman', field: 'Salesman_Name', width: 90 },
        ];

        this.customerList = this.customerList1;
        this.AreaList = [];
        this.CityList = [];
        this.gridApiCust = params.api;
        this.gridColumnApiCust = params.columnApi;
        setTimeout(() => {
            this.gridColumnApiCust = params.columnApi;
            this.gridApiCust.sizeColumnsToFit();
            this.sortCustNameAsc();
            var index = 0;
            if (this.f_chknum(this.LastSelectedId) > 0) {
                setTimeout(() => {
                    index = this.gridApiCust.getModel().rowsToDisplay.map(item => item.data.Customer_ID).indexOf(this.LastSelectedId);
                    if (index >= 0) {
                        this.gridApiCust.ensureIndexVisible(index);
                    }
                    setTimeout(() => {
                        var RowCount = this.gridApiCust.getModel().getRowCount();
                        if (RowCount >= index && RowCount > 0) {
                            this.SelectedRowIndex = index;
                            this.gridApiCust.getModel().getRow(index).setSelected(true);
                        }
                    }, 200);
                }, 500);
            }
            $('#filter-text-box').focus().select();
            if (this.SerachValue) {
                this.searchValue = this.SerachValue;
                this.quickSearch("", "customer", 1);
            } else {
                this.SelectedRowIndex = index;
                var rowCount = this.gridApiCust.getModel().getRowCount();
                if (rowCount >= index && rowCount > 0) {
                    this.selectedCustomerInfo = this.gridApiCust.getModel().getRow(index).setSelected(true);
                }
               
            }
            if (!this.SerachValue) {
                this.searchValue = this.SerachValue;
                this.quickSearch("", "customer", 1);
                this.SelectedRowIndex = index;
                var RowCount = this.gridApiCust.getModel().getRowCount();
                if (RowCount >= index && RowCount > 0) {
                    this.selectedCustomerInfo = this.gridApiCust.getModel().getRow(index).setSelected(true);
                }
            }
        }, 500);

        this.defaultColDef = {
            resizable: true,
        };
        this.defaultColDef = {
            resizable: true,
            sortable: true,
        };
    }

    gridEventDown(event) {
        if (event.keyCode == 13) {
            this.custSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus();
            this.searchValue = event.key
            this.quickSearch('', 'customer', 0);
        }
    }

    private custSelectionMain(self: this) {
        var RowCount = this.gridApiCust.getModel().getRowCount();
        if (RowCount == 0) {
            return false;
        }
        let selectedRows = self.gridApiCust.getSelectedRows();
        let cust = selectedRows[0];
        var EnterEventTriggerd = this.f_chknum($('.template-hidden-values #HiddenCustEnterEventTriggered').val());
        if (this.DisableClose == 1 || EnterEventTriggerd) {
            return false;
        }
        let searchValue = this.f_chkString(this.searchValue);

        if (cust != undefined && this.f_chknum(cust.Customer_ID) > 0) {
            cust.Outstanding_Amount = this.Outstanding_Amount;
            this.SelectedCustomer.emit(cust);
        } else {
            let data = {
                "Customer_ID": cust.Customer_ID,
                "Company_ID": this.unitInfo.Company_ID,
                "Unit_ID": this.unitInfo.Unit_ID,
            };
            this.http.get('/api/customers/getCustomerOutstanding', { params: data })
                .subscribe((response: any) => {
                    this.Outstanding_Amount = 0;
                    if (response.length > 0) {
                        this.Outstanding_Amount = response[0]["Outstanding_Amt"];
                        cust.Outstanding_Amount = this.Outstanding_Amount;
                    }
                    this.SelectedCustomer.emit(cust);
                });
        }
    }

    invoiceInfo: any;
    todayD: any;
    invoiceInfo1: any;
    Customer_GSTNo: any;
    Customer_Name: any;
    Salesman_Name: any;
    Sales_Margin: any;
    Customer_Address1: any;
    Customer_Full_Address: any;
    Customer_Mobile: any;
    Customer_Phone: any;
    Customer_EmailID: any;
    tax_Payer_type: any;
    DLNo_1: any;
    CreditLimit: any;
    CreditDays: any;
    TradeDiscount: any;
    TradeMode_Desc: any;
    Customer_ID: any;
    Outstanding_Amount: any;
    Customer_Status: any;
    Customer_StatusReason: any;
    busy: Subscription;
    selectedCustomer: any;
    CustomerReason_Desc: any;
    PaymentType: any;
    PayTerm_Desc: any;
    DL_Expired_Msg: any;

    custSelected(event) {
        let selectedRowCust = this.gridApiCust.getSelectedRows();
        // console.log("============ selectedRowCust ==>>", selectedRowCust);
        var SelectedRowIndex = [];
        SelectedRowIndex = this.gridApiCust.getSelectedNodes();
        var index = 0;
        if (SelectedRowIndex.length > 0) {
            index = this.customerList.map(item => item.Customer_ID).indexOf(SelectedRowIndex[0].data.Customer_ID);
            // console.log("============ index ==>>", index);
            // this.SelectedRowIndex = Number(this.gridApiCust.getRowNode(index).rowIndex);
             this.SelectedRowIndex = Number(SelectedRowIndex[0].rowIndex);
        } else {
            this.SelectedRowIndex = 0;
        }
        this.selectedCustomerInfo = selectedRowCust[0];
        this.Customer_GSTNo = this.selectedCustomerInfo.Customer_GSTNo;
        this.Customer_Name = this.selectedCustomerInfo.Customer_Name;
        this.Customer_Address1 = this.selectedCustomerInfo.Customer_Address1;
        this.Customer_Full_Address = this.selectedCustomerInfo.Customer_Full_Address;
        this.Customer_Mobile = this.selectedCustomerInfo.Customer_Mobile;
        this.Customer_Phone = this.selectedCustomerInfo.Customer_Phone;
        this.Customer_EmailID = this.selectedCustomerInfo.Customer_EmailID;
        this.tax_Payer_type = this.selectedCustomerInfo.TaxPayer_Type;
        this.DLNo_1 = this.selectedCustomerInfo.DL_No1;
        this.CreditLimit = this.selectedCustomerInfo.CreditLimit;
        this.CreditDays = this.selectedCustomerInfo.CreditDays;
        this.TradeDiscount = this.selectedCustomerInfo.TradeDiscount;
        this.TradeMode_Desc = this.selectedCustomerInfo.TradeMode_Desc;
        this.Customer_ID = this.selectedCustomerInfo.Customer_ID;
        this.Customer_Status = this.selectedCustomerInfo.Customer_Status;
        this.Customer_StatusReason = this.selectedCustomerInfo.Customer_StatusReason;
        this.Salesman_Name = this.selectedCustomerInfo.Salesman_Name;
        this.Sales_Margin = this.selectedCustomerInfo.Sales_Margin;
        this.Outstanding_Amount = 0;
        this.selectedCustomerInfo.LastInvoiceDays = 0;
        this.selectedCustomerInfo.Outstanding_Amount = 0;
        this.invoiceInfo = [];
        this.CustomerReason_Desc = this.selectedCustomerInfo.CustomerReason_Desc;
        this.PaymentType = this.selectedCustomerInfo.PaymentType;
        this.PayTerm_Desc = this.selectedCustomerInfo.PayTerm_Desc;
        this.DL_Expired_Msg = this.selectedCustomerInfo.DL_Expired_Msg;

        this.GetCustomerOutstanding(this.selectedCustomerInfo.Customer_ID);
    }

    httpCalling: any;
    GetCustomerOutstanding = debounce((Customer_ID) => {
        let data = {
            "Customer_ID": Customer_ID,
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
        };
        this.httpCalling = this.http.get('/api/customers/getCustomerOutstanding', { params: data })
            .subscribe((response: any) => {
                this.selectedCustomerInfo.Outstanding_Amount = 0;
                if (response.length > 0) {
                    this.selectedCustomerInfo.Outstanding_Amount = response[0]["Outstanding_Amt"];
                    this.Outstanding_Amount = response[0]["Outstanding_Amt"];
                }
            });
    }, 1000);

    onCustSelectionChanged(event) {
        this.custSelectionMain(this);
    }

    quickSearch_old(event, id, OnLoad = 0){
        if (event.which == 37 || event.which == 38 || event.which == 39 || event.which == 16 || event.which == 17 || event.which == 70) {
            return false;
        }
        if(event.which == 27) {
            this.d();
            return false;
        }
        if (event.which == 40) {
            let RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
                this.gridApiCust.setFocusedCell(this.SelectedRowIndex, "Customer_Code");
            }
            return false;
        } else {
            this.SelectedRowIndex = 0;
        }
        var IsSearchContain = "";
        let search = this.f_chkString(this.searchValue);
        if(search === this.LastSearchText) {
            return false;
        }
        this.LastSearchText = search;
        var sportsFilterComponent = this.gridApiCust.getFilterInstance(this.filterType);
        var AddFilterComp = this.gridApiCust.getFilterInstance("Customer_Address1");
        var AddFilterArea = this.gridApiCust.getFilterInstance("Area_Name");
        if (this.searchValue) {
            let custoemrae = search.split(',');
           // let addsearch = search.indexOf(',') >= 0 ? this.f_chkString(search.substring(search.indexOf(',') + 1)) : "";
            let addsearch = custoemrae.length >= 2 ? custoemrae[1] : "";
            let areasearch = custoemrae.length >= 3 ? custoemrae[2] : "";


            search = search.indexOf(',') < 0 ? search : search.substring(0, search.indexOf(','));
            let search1 = search.split(" ");
            var Slen1 = search.length;
            var Slen = search1.length;
            if (Slen1 >= 3) {
                if (search1.length > 1) {
                    sportsFilterComponent.setModel({
                        condition2: {
                            type: "contains",
                            filter: search1[1]
                        },
                        condition1: {
                            type: "startsWith",
                            filter: search1[0]
                        },
                        condition3: {
                            type: "startsWith",
                            filter: search1[1]
                        },
                        operator: "AND"
                    });
                } else {
                    var index = search.indexOf("%");
                    if (index >= 0) {
                        search = search.replace(/%/g, "");
                        IsSearchContain = search;
                    }
                    sportsFilterComponent.setModel({
                        type: (index >= 0) ? "contains" : "startsWith",
                        filter: search
                    });
                    if (index < 0) {
                        this.gridApiCust.onFilterChanged();
                        if (this.gridApiCust.getModel().getRowCount() == 0 && sportsFilterComponent) {
                            sportsFilterComponent.setModel({
                                type: "contains",
                                filter: search
                            });
                        }
                    }
                }
                
                if((addsearch && this.f_chknum(addsearch.length) > 0) && !(areasearch)) {
                    if (addsearch && this.f_chknum(addsearch.length) > 0) {
                        this.gridApiCust.onFilterChanged();
                        AddFilterComp.setModel({
                            type: "contains",
                            filter: addsearch
                        });


                        this.gridApiCust.onFilterChanged();
                        let TotalRowCount_1 = this.gridApiCust.getModel().getRowCount();

                        if(event.which == 8 && custoemrae.length >= 2 && custoemrae.length == 3){
                            this.gridApiCust.destroyFilter('Area_Name');
                        }
                        
                        if(TotalRowCount_1 == 0 && addsearch && this.f_chknum(addsearch.length) > 0){
                            if(event.which != 8){
                                this.gridApiCust.destroyFilter('Customer_Address1');
                            }
                            
                            /* setTimeout(() => { */
                                if (addsearch && this.f_chknum(addsearch.length) > 0) {
                                    this.gridApiCust.onFilterChanged();
                                    AddFilterArea.setModel({
                                        type: "startsWith",
                                        filter: addsearch
                                    });
                                } else {
                                    this.gridApiCust.destroyFilter('Area_Name');
                                }
                            /* }, 200); */
                        }

                        if(TotalRowCount_1 == 0 && !addsearch && this.f_chknum(addsearch.length) == 0){
                            this.gridApiCust.destroyFilter('Area_Name');
                        }
                    } else {
                        this.gridApiCust.destroyFilter('Customer_Address1');
                    }
                }

                if(!addsearch && !addsearch){
                    this.gridApiCust.onFilterChanged();
                    this.gridApiCust.destroyFilter('Customer_Address1');
                    this.gridApiCust.destroyFilter('Area_Name');
                }
                
                if(addsearch && (areasearch && this.f_chknum(areasearch.length) > 0)) {
                    if (areasearch && this.f_chknum(areasearch.length) > 0) {
                        this.gridApiCust.onFilterChanged();
                        AddFilterArea.setModel({
                            type: "startsWith",
                            filter: areasearch
                        });
                    } else {
                       this.gridApiCust.destroyFilter('Area_Name');
                    }
                }
                
                /* if(addsearch && !areasearch){
                    this.gridApiCust.destroyFilter('Area_Name');
                } */
            } else {
                IsSearchContain = search;
            }
        } else {
            this.gridApiCust.setFilterModel(null);
        }
        this.gridApiCust.onFilterChanged();
        var TotalRowCount = this.gridApiCust.getModel().getRowCount();
        if (TotalRowCount > 0 && OnLoad == 0) {
            if ((IsSearchContain ? IsSearchContain : "").length > 0) {
                IsSearchContain = IsSearchContain.toUpperCase();
                var inde = this.gridApiCust.getModel().rowsToDisplay.filter(item => item.data.SearchCustomer.startsWith(IsSearchContain));
                if (inde.length > 0) {
                    this.SelectedRowIndex = this.gridApiCust.getModel().rowsToDisplay.map(item => item.data.Customer_ID).indexOf(inde[0].data.Customer_ID);
                    var RowCount = this.gridApiCust.getModel().getRowCount();
                    if (RowCount > 0) {
                        this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
                    }
                } else {
                    this.SelectedRowIndex = 0;
                }
            } else {
                this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
            }
            if (this.SelectedRowIndex >= TotalRowCount) {
                this.SelectedRowIndex = 0;
            }
            var RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        } else {
            this.SelectedRowIndex = 0;
            var RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        }
        var RowCount = this.gridApiCust.getModel().getRowCount();
        if ((event.which == 13 || event.which == 40) && RowCount >= this.SelectedRowIndex && RowCount > 0) {
            this.gridApiCust.setFocusedCell(this.SelectedRowIndex, "Customer_Code");
        }
    };
    
    quickSearch(event, id, OnLoad = 0){
        if (event.which == 37 || event.which == 38 || event.which == 39 || event.which == 16 || event.which == 17 || event.which == 70) {
            return false;
        }
        if(event.which == 27) {
            this.d();
            return false;
        }
        if (event.which == 40) {
            let RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
                this.gridApiCust.setFocusedCell(this.SelectedRowIndex, "Customer_Code");
            }
            return false;
        } else {
            this.SelectedRowIndex = 0;
        }
        var IsSearchContain = "";
        let search = this.f_chkString(this.searchValue).toLocaleUpperCase();
        if(search === this.LastSearchText) {
            return false;
        }
        this.LastSearchText = search;
        var sportsFilterComponent = this.gridApiCust.getFilterInstance(this.filterType);
        var AddFilterComp = this.gridApiCust.getFilterInstance("Customer_Address1");
        var AddFilterArea = this.gridApiCust.getFilterInstance("Area_Name");
        if (this.searchValue) {
            let custoemrae = search.split(',');
           // let addsearch = search.indexOf(',') >= 0 ? this.f_chkString(search.substring(search.indexOf(',') + 1)) : "";
            let addsearch = custoemrae.length >= 2 ? custoemrae[1] : "";
            let areasearch = custoemrae.length >= 3 ? custoemrae[2] : "";


            search = search.indexOf(',') < 0 ? search : search.substring(0, search.indexOf(','));
            let search1 = search.split(" ");
            var Slen1 = search.length;
            var Slen = search1.length;
            if (Slen1 >= 3) {
                if (search1.length > 1) {
                    // sportsFilterComponent = this.gridApiCust.getFilterInstance('Customer_LegalName');
                    sportsFilterComponent.setModel({
                        
                        condition1: {
                            type: "startsWith",
                            filter: search
                        },
                        condition2: {
                            type: "contains",
                            filter: search1[1]
                        },
                        
                        condition3: {
                            type: "startsWith",
                            filter: search1[1]
                        },
                        condition4: {
                            type: "contains",
                            filter: search1[2]
                        },
                        condition5: {
                            type: "startsWith",
                            filter: search1[2]
                        },
                        operator: "AND"
                    });

                    sportsFilterComponent = this.customerList.filter(item => {
                        return search1.every((filterWord) => item.Customer_LegalName.toLocaleUpperCase().indexOf(filterWord) >= 0);
                    });
    
                    sportsFilterComponent.map(item => {
                        item.SearchFilterValue = 3;
                        if (item[this.filterType].toLocaleUpperCase().includes(search)) {
                            item.SearchFilterValue = 2;
                        }
                        if (item[this.filterType].toLocaleUpperCase().startsWith(search)) {
                            item.SearchFilterValue = 1;
                        }
                    });
    
                    const sortModel = [
                        { colId: 'SearchFilterValue', sort: 'asc' }
                    ];

                    this.gridApiCust.setRowData(sportsFilterComponent);
                    this.gridApiCust.setSortModel(sortModel);
                    this.gridApiCust.onFilterChanged();
                } else {
                    var index = search.indexOf("%");
                    if (index >= 0) {
                        search = search.replace(/%/g, "");
                        IsSearchContain = search;
                    }
                    sportsFilterComponent.setModel({
                        type: (index >= 0) ? "contains" : "startsWith",
                        filter: search
                    });
                    if (index < 0) {
                        this.gridApiCust.onFilterChanged();
                        if (this.gridApiCust.getModel().getRowCount() == 0 && sportsFilterComponent) {
                            sportsFilterComponent.setModel({
                                type: "contains",
                                filter: search
                            });
                        }
                    }
                }
                
                console.log("====>",addsearch, "===>", areasearch);
                if((addsearch && this.f_chknum(addsearch.length) > 0) && !(areasearch)) {
                    if (addsearch && this.f_chknum(addsearch.length) > 0) {
                        this.gridApiCust.onFilterChanged();
                        AddFilterComp.setModel({
                            type: "contains",
                            filter: addsearch
                        });


                        this.gridApiCust.onFilterChanged();
                        let TotalRowCount_1 = this.gridApiCust.getModel().getRowCount();

                        if(event.which == 8 && custoemrae.length >= 2 && custoemrae.length == 3){
                            this.gridApiCust.destroyFilter('Area_Name');
                        }
                        
                        if(TotalRowCount_1 == 0 && addsearch && this.f_chknum(addsearch.length) > 0){
                            if(event.which != 8){
                                this.gridApiCust.destroyFilter('Customer_Address1');
                            }
                            
                            /* setTimeout(() => { */
                                if (addsearch && this.f_chknum(addsearch.length) > 0) {
                                    this.gridApiCust.onFilterChanged();
                                    AddFilterArea.setModel({
                                        type: "startsWith",
                                        filter: addsearch
                                    });
                                } else {
                                    this.gridApiCust.destroyFilter('Area_Name');
                                }
                            /* }, 200); */
                        }

                        if(TotalRowCount_1 == 0 && !addsearch && this.f_chknum(addsearch.length) == 0){
                            this.gridApiCust.destroyFilter('Area_Name');
                        }
                    } else {
                        this.gridApiCust.destroyFilter('Customer_Address1');
                    }
                }

                if(!addsearch && !addsearch && event.which == 8){
                    this.gridApiCust.onFilterChanged();
                    this.gridApiCust.destroyFilter('Customer_Address1');
                    this.gridApiCust.destroyFilter('Area_Name');
                }
                
                if(addsearch && (areasearch && this.f_chknum(areasearch.length) > 0)) {
                    if (areasearch && this.f_chknum(areasearch.length) > 0) {
                        this.gridApiCust.onFilterChanged();
                        AddFilterArea.setModel({
                            type: "startsWith",
                            filter: areasearch
                        });
                    } else {
                       this.gridApiCust.destroyFilter('Area_Name');
                    }
                }
                
                /* if(addsearch && !areasearch){
                    this.gridApiCust.destroyFilter('Area_Name');
                } */
            } else {
                IsSearchContain = search;
            }
        } else {
            // this.gridApiCust.setFilterModel(null);
            sportsFilterComponent = this.customerList;
            this.gridApiCust.setRowData(sportsFilterComponent);
            this.gridApiCust.setSortModel([]);
        }
        this.gridApiCust.onFilterChanged();
        var TotalRowCount = this.gridApiCust.getModel().getRowCount();
        if (TotalRowCount > 0 && OnLoad == 0) {
            if ((IsSearchContain ? IsSearchContain : "").length > 0) {
                IsSearchContain = IsSearchContain.toUpperCase();
                var inde = this.gridApiCust.getModel().rowsToDisplay.filter(item => item.data.SearchCustomer.startsWith(IsSearchContain));
                if (inde.length > 0) {
                    this.SelectedRowIndex = this.gridApiCust.getModel().rowsToDisplay.map(item => item.data.Customer_ID).indexOf(inde[0].data.Customer_ID);
                    var RowCount = this.gridApiCust.getModel().getRowCount();
                    if (RowCount > 0) {
                        this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
                    }
                } else {
                    this.SelectedRowIndex = 0;
                }
            } else {
                this.gridApiCust.ensureIndexVisible(this.SelectedRowIndex);
            }
            if (this.SelectedRowIndex >= TotalRowCount) {
                this.SelectedRowIndex = 0;
            }
            var RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        } else {
            this.SelectedRowIndex = 0;
            var RowCount = this.gridApiCust.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiCust.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        }
        var RowCount = this.gridApiCust.getModel().getRowCount();
        if ((event.which == 13 || event.which == 40) && RowCount >= this.SelectedRowIndex && RowCount > 0) {
            this.gridApiCust.setFocusedCell(this.SelectedRowIndex, "Customer_Code");
        }
    };

    outstandingClick() {
        this.modalReference = this.modalService.open(this.OS, { size: 'sm', windowClass: 'data-show ledger-modal-popup' });
        var self = this;
        this.modalReference.result.then(() => {
            self.modalReference = undefined;
            self.removeHotKeyServices();
        }, () => {
            self.modalReference = undefined;
            self.removeHotKeyServices();
        });
    }

    removeHotKeyServices() {
        this.hotkeysService.remove(this.hotkeyList);
        this.hotkeysService.add(this.hotkeyList);
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    CustomerNotesList: any;
    GetCustomerNotes(CustID) {
        let data = { Customer_ID: CustID };
        this.busy = this.http.post('api/Salesinvoices/GET_CUSTOMER_NOTES', data)
            .subscribe(Response => {
                this.CustomerNotesList = Response;
            });
    }
    CustNotescolumnDefs: any;
    prodmodalReference: NgbModalRef;

    OpenCustomerNotesPopup() {
        this.GetCustomerNotes(this.Customer_ID);
        this.prodmodalReference = this.modalService.open(this.CustomerNotespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth' });

        this.CustNotescolumnDefs = [
            { headerName: 'Description', field: 'Description', width: 750 },
            { headerName: 'Date', field: 'Notes_Date', width: 100 }
        ]
    }

    movepopup(ctrl) {
        this.GetCustomerReview(this.Customer_ID);
    }

    datalist: any;
    CustomerReviewList: any;
    GetCustomerReview(id) {
        let data = {
            "Post_Account_Id": id
        };
        this.http.post('/api/SalesInvoices/GetCustomerReview', data)
            .subscribe(response => {

                this.prodmodalReference = this.modalService.open(this.cuatInfopopup, { size: 'sm', windowClass: 'data-show ledger' });

                this.CustomerReviewList = response;
                this.datalist = this.CustomerReviewList
                this.genrateBarChart();
                this.genrateLineChart();
                this.genrateLineChart1();
            });
    }

    genrateBarChart() {
        var self = this;
        var chart = bb.generate({
            bindto: "#chart",
            data: {
                json: self.datalist,
                type: "bar",
                "colors": {
                    "SalesReturn": "#FFFF00",
                    "Sale": "#0000FF",
                    "ReceiptAmt": "#FFA500",
                    "ExpiryReturn": "#FF0000"

                },
                keys: {
                    x: "Doc_Date", 
                    value: ["SalesReturn", "Sale", "ReceiptAmt", "ExpiryReturn"],
                }
            },
            size: {
                width: 800,
                height: 200
            },
            axis: {
                x: {
                    type: "category",

                }
            },
            bar: {
                width: {
                    ratio: 1,
                    max: 20
                }
            },


        });
    }

    genrateLineChart() {
        var self = this;
        var chart = bb.generate({
            bindto: "#LineChart",
            data: {
                json: self.datalist,
                "colors": {
                    "Sale": "#0000FF",

                },
                keys: {
                    x: "Doc_Date", 
                    value: ["Sale"],
                },
            },
            size: {
                width: 500,
                height: 200
            },
            axis: {
                x: {
                    type: "category",

                }
            },
            bar: {
                width: {
                    ratio: 0.1,
                    max: 5
                }
            },

        });


    }

    genrateLineChart1() {
        var self = this;
        var chart = bb.generate({
            bindto: "#LineChart1",
            data: {
                json: self.datalist,
                "colors": {
                    "ReceiptAmt": "#FFA500"

                },
                keys: {
                    x: "Doc_Date",
                    value: ["ReceiptAmt"],
                }
            },
            size: {
                width: 500,
                height: 200
            },
            axis: {
                x: {
                    type: "category",

                }
            },
            bar: {
                width: {
                    ratio: 0.1,
                    max: 5
                }
            },

        });
    }

    SalesHistcolumnDefs: any;
    SalesHistList: any;
    SearchModel: any;
    OpenSalesHistoryPopup(SalesHistorypopup) {
        this.SalesHistList = [];
        if (!this.selectedCustomerInfo.Customer_ID) {
            this.toastWarningMsg("Customer Not Selected");
            return;
        }
        this.SearchModel = { "From_Date": new Date(), "To_Date": new Date() };
        this.modalService.open(SalesHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });
        setTimeout(() => {
            $('input[name=From_Date]').focus().select();
        }, 100);
        this.SalesHistcolumnDefs = [
            { headerName: 'Inv No', field: 'Invoice_No', width: 120 },
            { headerName: 'Inv Date', field: 'Invoice_Date', width: 100 },
            { headerName: 'Product Code', field: 'Product_Code', width: 120 },
            { headerName: 'Product Name', field: 'Product_Desc', width: 150 },
            { headerName: 'Batch No', field: 'Batch_No', width: 100 },
            { headerName: 'Exp Date', field: 'Expiry_Date', width: 80 },
            { headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'PTR', field: 'PTR', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Rate', field: 'Rate', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: { 'text-align': 'right' } },
        ];
        this.GetCustomerSalesHistory();
    }

    GetCustomerSalesHistory() {
        let data = { "Customer_ID": this.selectedCustomerInfo.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID, "From_Date": moment(this.SearchModel.From_Date).format('YYYY-MM-DD'), "To_Date": moment(this.SearchModel.To_Date).format('YYYY-MM-DD') };
        this.busy = this.http.post('api/Salesinvoices/Get_Customer_Sales_History', data)
            .subscribe(Response => {
                this.SalesHistList = Response;
                setTimeout(() => {
                    $('input[name=From_Date]').focus().select();
                }, 100);
            });
    }

    From_Datechange(e) {
        if (e.which == 13) {
            $('#To_Date').focus();
        }
    }

    To_Datechange(e) {
        if (e.which == 13) {
            $('#okbtn1').focus();
        }
    }

    clearAllFilter() {
        this.searchValue = '';
    }
    orderSearch: any;
    ledgerSearch: any;
    expiryLedgerModal(expiryLedger) {
        this.getAllExpiryLedger();
        this.modalService.open(expiryLedger, { size: 'lg', windowClass: 'data-show expiryledgermodal order-history-modal' });
        setTimeout(() => {
            $('.order-history-modal input#From_Date').focus().select();
            this.initModalQuery('.order-history-modal');
        }, 200);

        this.orderSearch.From_Date = this.oneMonthAgo();
        this.orderSearch.To_Date = new Date();
        /*  } */
    }

    initModalQuery(className) {
        var parent = this;
        $(className).on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
            var self = $(this)
                , form = self.parents(className + ':eq(0)')
                , focusable
                , next
                ;
            if (e.keyCode == 13) {
                if (this.classList.contains('custom-date')) {
                    parent.customDateFormat.GetCustomDateFormat(this, parent.datePipe);
                }
                focusable = form.find('input:not([type="radio"]), input[role=combobox]').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#okbtn').focus();
                }
                return false;
            }
        });
    }

    gridApiExpLdge: any;
    gridColumnApiExpLdge: any;
    ExpiryLedgerRowData: any;
    ExpiryLedgerRowDataList: any;
    ExpiryLedgercolumnDefs: any;
    ExpiryLedgerDatacolumnDefs: any;
    ExpiryLedgerRowDataFooter: any;
    ledgerDebit: any;
    ExpiryledgerDebit: any;
    ledgerCredit: any;
    ExpiryledgerCredit: any;
    ledgerClosingBalance: any;
    ExpiryledgerClosingBalance: any;
    ledgerOpeningBalance: any;
    ExpiryledgerOpeningBalance: any;
    ExpiryledgerDueBalance: any;
    ExpiryledgerDetails: any;
    public rowClassRules: any;
    expiryLedgerGridReady(params) {
        this.gridApiExpLdge = params.api;
        this.gridColumnApiExpLdge = params.columnApi;
        this.gridApiExpLdge.sizeColumnsToFit();
    }
    getAllExpiryLedger() {
        var parent = this;
        $(document).ready(function () {
            $('.ag-root.ag-layout-normal').css('overflow', 'inherit');
            $('.ag-root.ag-layout-normal').css('width', 'auto');
        });
        if (this.ledgerSearch.From_Date == null || this.ledgerSearch.From_Date == "") {
            this.toastWarningMsg("From Date cannot be blank!");
            setTimeout(() => {
                $('#From_Date').focus();
            }, 300);
            return false;
        }
        else if (this.ledgerSearch.To_Date == null || this.ledgerSearch.To_Date == "") {
            this.toastWarningMsg("To Date cannot be blank!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else if (Date.parse(this.ledgerSearch.To_Date) < Date.parse(this.ledgerSearch.From_Date)) {
            this.toastWarningMsg("From date cannot be greater than to date!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else {

            let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
            let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
            var data = {
                "Customer_ID": this.selectedCustomerInfo.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID,
                "From_Date": From_Date, "To_Date": To_Date
            };
            this.ExpiryLedgerRowData = [];
            this.ExpiryLedgerRowDataList = [];
            this.busy = this.http.post('/api/customers/Get_Expity_Ledger_Customer_Wise', data)
                .subscribe(response => {
                    var res = [];
                    res.push(response);
                    let self = this;
                    this.ExpiryLedgercolumnDefs = [
                        { headerName: 'Doc No', field: 'TransNo', width: 100 },
                        {
                            headerName: 'Date', field: 'Doc_Date', width: 200,
                            cellRenderer: (data) => {
                                if (data.value) {
                                    return moment(data.value).format(self.dateFormat.dateInputFormat);
                                }
                                else {
                                    return '-';
                                }
                            }
                        },
                        { headerName: 'Debit', field: 'Debit', width: 100, cellStyle: { textAlign: 'right' } },
                        { headerName: 'Credit', field: 'Credit', width: 100, cellStyle: { textAlign: 'right' } },
                        { headerName: 'Due/Reference', field: 'Balance', cellStyle: { textAlign: 'right' } },
                        { headerName: '', field: 'Flagexyz', width: 50 },
                        { headerName: '', field: 'DRCR', width: 50 }
                    ];


                    this.ExpiryLedgerDatacolumnDefs = [
                        { headerName: 'Doc No', field: 'TransNo', width: 100 },
                        {
                            headerName: 'Date', field: 'Doc_Date', width: 200,
                            cellRenderer: (data) => {
                                if (data.value) {
                                    return moment(data.value).format(self.dateFormat.dateInputFormat);
                                }
                                else {
                                    return '-';
                                }
                            }
                        },
                        { headerName: 'Amount', field: 'Invoice_Amount', width: 100, cellStyle: { textAlign: 'right' } },
                        { headerName: 'Remark', field: 'Remarks', width: 200 },

                    ];

                    this.ExpiryLedgerRowData = res[0].ledgerData;
                    this.ExpiryLedgerRowDataFooter = res[0].ledgerFooterData;
                    this.ExpiryledgerDetails = this.ExpiryLedgerRowDataFooter[0];
                    this.ExpiryledgerDebit = this.ExpiryledgerDetails.Debit;
                    this.ExpiryledgerCredit = this.ExpiryledgerDetails.Credit;
                    this.ExpiryledgerClosingBalance = this.ExpiryledgerDetails.Closing_Balance;
                    this.ExpiryledgerOpeningBalance = this.ExpiryledgerDetails.Opening_Balance;
                    this.ExpiryledgerDueBalance = this.ExpiryledgerDetails.DueBalance;
                    var TotalExpiryLedgerRowData = { "TransNo": "Total Count : " + this.ExpiryLedgerRowData.length, "Doc_Date": "Total :", "Debit": 0, "Credit": 0, "Balance": 0 };

                    TotalExpiryLedgerRowData.Debit = (this.ExpiryLedgerRowData.reduce(function (acc, sum) {
                        return acc + parent.f_chknum(sum.Debit)
                    }, 0));
                    TotalExpiryLedgerRowData.Credit = (this.ExpiryLedgerRowData.reduce(function (acc, sum) {
                        return acc + parent.f_chknum(sum.Credit)
                    }, 0));
                    TotalExpiryLedgerRowData.Balance = (this.ExpiryLedgerRowDataFooter.reduce(function (acc, sum) {
                        return acc + parent.f_chknum(sum.DueBalance)
                    }, 0));



                    setTimeout(() => {
                        this.gridApiExpLdge.setPinnedBottomRowData([TotalExpiryLedgerRowData])
                    }, 300);
                    if (this.ExpiryLedgerRowData.length > 0) {
                        setTimeout(() => {
                            let allColumnIds = [];
                            this.gridApiExpLdge.getModel().getRow(0).setSelected(true);
                            this.gridApiExpLdge.setFocusedCell(0, "TransNo");
                            this.gridColumnApiExpLdge.getAllColumns().forEach(function (column) {
                                allColumnIds.push(column.colId);
                            });
                            this.gridColumnApiExpLdge.autoSizeColumns(allColumnIds);
                            this.gridApiExpLdge.sizeColumnsToFit();


                        }, 100);
                    } else {
                        setTimeout(() => {
                            let allColumnIds = [];
                            this.gridColumnApiExpLdge.getAllColumns().forEach(function (column) {
                                allColumnIds.push(column.colId);
                            });
                            this.gridColumnApiExpLdge.autoSizeColumns(allColumnIds);
                            this.gridApiExpLdge.sizeColumnsToFit();
                        }, 100);
                    }
                    this.rowClassRules = {
                        "solution-solved": function (params) {
                            var Status_ID = params.data.Reconciled;
                            return Status_ID == 1;
                        }
                    };
                })
        }

    }
    expiryLedgerSelectionChanged() {
        var selectedRows = this.gridApiExpLdge.getSelectedRows();
    }

    exportExcelExpiryLedger() {

        this.selectedCustomer = this.gridApiExpLdge.getSelectedRows();

        let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let row = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + 'Customer Name :' + this.selectedCustomer.Customer_LegalName + '\n' + 'From : ' + From_Date + ',' + 'To : ' + To_Date
        let d = new Date();
        var fName = 'Expiry_History_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: row,
            fileName: fName,
        };
        this.gridApiExpLdge.exportDataAsCsv(params);
    }

    ExpiryledgerRowSelected: any = [];
    gridApiExpLdgeData: any;
    gridColumnApiExpLdgeData: any;
    ExpiryledgeronSelectionChanged() {
        var self = this;
        var selectedRows = this.gridApiExpLdge.getSelectedRows();
        this.ExpiryledgerRowSelected = selectedRows[0];
        if (this.ExpiryledgerRowSelected.Sales_Breakage_Expiry_ID > 0) {
            var data = { "Transaction_Ref_No": this.ExpiryledgerRowSelected.Sales_Breakage_Expiry_ID }
            this.busy = this.http.post('/api/customers/Get_Adjusted_Document', data)
                .subscribe(response => {
                    this.ExpiryLedgerRowDataList = response;
                })
        } else {
            this.ExpiryLedgerRowDataList = [];
        }

    }

    expiryLedgerDataGridReady(params) {
        this.gridApiExpLdgeData = params.api;
        this.gridColumnApiExpLdgeData = params.columnApi;
        this.gridApiExpLdgeData.sizeColumnsToFit();
    }

    sortCodeAsc() {
        const sortModel = [
            { colId: 'Customer_Code', sort: 'asc' }
        ];
        this.gridApiCust.setSortModel([]);
        this.gridApiCust.setSortModel(sortModel);
    }

    sortAltCodeAsc() {
        const sortModel = [
            { colId: 'altCode', sort: 'asc' }
        ];
        this.gridApiCust.setSortModel([]);
        this.gridApiCust.setSortModel(sortModel);
    }

    sortCustNameAsc() {
        const sortModel = [
            { colId: 'Customer_LegalName', sort: 'asc' }
        ];
        this.gridApiCust.setSortModel([]);
        this.gridApiCust.setSortModel(sortModel);
    }

    overlayLoadingTemplate_1:any;
    getCustomers() {
        this.overlayLoadingTemplate_1 = '<span class="ag-overlay-loading-center">Please wait, customer list is loading ...</span>';
        this.gridApiCust.showLoadingOverlay();
        this.customerList = [];
        this.searchValue = '';
        const { CDN_Enabled, CDN_Domain, Company_Code, Unit_ID, Company_ID, CurrentFYear, _id } = this.unitInfo;
        let data = {
            Unit_ID,
            Company_ID,
            Fyear: CurrentFYear,
            CreatedBy: _id,
        };
        this.busy = this.http.get(`${CDN_Enabled ? "//" + CDN_Domain : ""}/api/${Company_Code}/customers/masterList/salesInvoice`,{ params: data })
            .subscribe(response => {
                this.customerList = response;
                this.CustomerListRefresh.emit(this.customerList); 
                setTimeout(() => {
                    $('#filter-text-box').focus();
                }, 200);
            });
    }

    holdsalesreturnColumnList = [];
    holdsalesreturndata :any
    getHoldSalesReturnList() {
        this.custfiltervalue1 = "";
        let self = this;
        let selectedRows = self.gridApiCust.getSelectedRows();
        let cust = selectedRows[0];
    var data = { "Company_ID": this.unitInfo.Company_ID, "Unit_ID": this.unitInfo.Unit_ID, "Customer_ID": cust.Customer_ID , "FYear" : this.unitInfo.Fyear}
        
    this.busy = this.http.post('/api/customers/GetHoldSalesReturnListByCustomerID', data)
            .subscribe(response => {
            this.holdsalesreturnColumnList = [
                { headerName: 'Doc No', field: 'Doc_No', width: 150 },
                { headerName: 'Doc Date', field: 'Doc_Date', width: 150 },
                { headerName: 'Invoice No', field: 'Invoice_No', width: 150 },
                { headerName: 'Invoice Date', field: 'Invoice_Date', width: 150 },
                { headerName: 'Taxable Amt', field: 'Total_Taxable_Amount', width: 150 },
                { headerName: 'CGST Amt', field: 'Total_CGST_Amt', width: 150 },
                { headerName: 'SGST Amt', field: 'Total_SGST_Amt', width: 150 },
                { headerName: 'IGST Amt', field: 'Total_IGST_Amt', width: 150 },
                { headerName: 'RoundOff', field: 'RoundOffAmount', width: 150 },
                { headerName: 'Doc Amt', field: 'Total_BillAmount', width: 150 },
            ];
            this.holdsalesreturndata = response;
            
            let total_count = this.holdsalesreturndata ? this.holdsalesreturndata.length : 0;
            if(total_count > 0){
                var TotalHoldSalesRowData = { "Invoice_No": "Total : " ,"Invoice_Date": total_count, "Total_Taxable_Amount": 0,"Total_CGST_Amt":0,"Total_SGST_Amt" : 0, "Total_IGST_Amt" : 0, "RoundOffAmount" : 0, "Total_BillAmount": 0 };

                TotalHoldSalesRowData.Total_Taxable_Amount = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Total_Taxable_Amount)
                }, 0)).toFixed(2);
                TotalHoldSalesRowData.Total_CGST_Amt = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Total_CGST_Amt)
                }, 0)).toFixed(2);
                TotalHoldSalesRowData.Total_SGST_Amt = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Total_SGST_Amt)
                }, 0)).toFixed(2);
                TotalHoldSalesRowData.Total_IGST_Amt = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Total_IGST_Amt)
                }, 0)).toFixed(2);
                TotalHoldSalesRowData.RoundOffAmount = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.RoundOffAmount)
                }, 0)).toFixed(2);
                TotalHoldSalesRowData.Total_BillAmount = (this.holdsalesreturndata.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Total_BillAmount)
                }, 0)).toFixed(2);
                setTimeout(() => {
                    this.HoldsalesreturngridApi.setPinnedBottomRowData([TotalHoldSalesRowData])
                }, 300);
                
            }
        });
           
    //    setTimeout(() => {
        this.modalReference = this.modalService.open(this.holdsalesreturn, { size: 'lg', windowClass: 'data-show width-95 vendorledger' });
    };

    HoldsalesreturngridApi:any;
    HoldsalesreturngridColumnApi:any;
    onholdsalesreturnGridReady(params){
        this.HoldsalesreturngridApi = params.api;
        this.HoldsalesreturngridColumnApi = params.columnApi;
    }

    // openSRDetailDilog(holdsalesreturndata){
    //     this.modalReference = this.modalService.open(holdsalesreturndata, { size: 'lg', windowClass: 'data-show width-95 vendorledger' });
    // }

    GPRowDataList:any = [];
    GPColumnList:any = [];

    getGPDetailsForCustomer(){
        let self = this;
        let selectedRows = self.gridApiCust.getSelectedRows();
        let cust = selectedRows[0];
        var data = { "Customer_ID": cust.Customer_ID }
        this.busy = this.http.post('/api/customers/GetCustomerGPDetails', data)
            .subscribe(response => {
                this.GPRowDataList = response;
                this.GPColumnList=[
                    { headerName: 'Month', field: 'MONTH', width: 80 },
                    { headerName: 'GP %', field: 'GP_Percent', width: 80 , cellStyle: { textAlign: "right" }},
                ]
                this.openDetailDilog(this.gpperlist);
            })
    }

    gridApiGPData: any;
    gridColumnApiGPeData: any;

    ongpGridReady(params){
        this.gridApiGPData = params.api;
        this.gridColumnApiGPeData = params.columnApi;
        this.gridApiGPData.sizeColumnsToFit();
    }

    openDetailDilog(gpperlist){
        this.modalReference = this.modalService.open(gpperlist, { size: 'lg', windowClass: 'data-show small-width' });
    }

    onPopupFilterTextBoxChanged() {
        let value = $('input#filter-text-box1').val()
        this.HoldsalesreturngridApi.setQuickFilter(value);
      };

    AreaListForFilter:any = [];
    getAreaList() {
        this.busy = this.http.get('/api/citys/getArealist/' + 0)
        .subscribe(response => {
            this.AreaList = response;
            this.AreaListForFilter = response;
            setTimeout(() => {
                // console.log("=== Area ID onload ==>", this.AreaID);
                if(this.LastSelectedAreaId.length > 0){
                    this.AreaID = this.LastSelectedAreaId;
                    this.onAreachange();
                }
            }, 200);
        })
    }

    getCityList() {
        this.busy = this.http.get('/api/citys/getCityslist/' + 0)
            .subscribe(response => {
                this.CityList = response;
                setTimeout(() => {
                    if(this.f_chknum(this.LastSelectedCityId)){
                        this.CityID = this.f_chknum(this.LastSelectedCityId);
                        this.onAreachange();
                    }
                }, 200);
            })
    }

    onAreachange(e:any = ''){
        this.customerList = [];
        
        if(this.f_chknum(this.CityID) == 0 && this.f_chknum(this.AreaID.length) > 0){
            let self = this;
            this.AreaList = this.AreaListForFilter;
            // console.log("========= this.AreaID =======>", this.AreaID);
            // console.log("========= Selected Area =======>", e);
            let UniqAreaName = [];
            if(!e){
                for(let i = 0; this.AreaID.length > i; i++){
                    UniqAreaName.push(...this.AreaListForFilter.filter(item => {
                        return self.f_chknum(item.Area_ID) == self.f_chknum(this.AreaID[i]);
                    }));
                }

                UniqAreaName = this.findUnique(UniqAreaName, d => d.Area_Name);
            }else{
                UniqAreaName = this.findUnique(e, d => d.Area_Name);
            }

       
            // console.log("======= UNIQ Area =========>", UniqAreaName);

            setTimeout(() => {
                this.searchValue = '';
                for(let i = 0; UniqAreaName.length > i; i++){
                    let custlist = (this.customerList1.filter(item => {
                        return self.f_chkString(item.Area_Name) == self.f_chkString(UniqAreaName[i].Area_Name);
                    }));
                    // console.log("===== Customer List ===>", custlist);
                    this.customerList.push(...custlist);
                }
                // console.log("=====1>", this.customerList);
                setTimeout(() => {
                    this.gridApiCust.setRowData(this.customerList);
                    this.gridApiCust.onFilterChanged();
                    $('#filter-text-box').focus();
                }, 200);
                this.CustomerAreadID.emit(this.AreaID);
            }, 100);
        }
        
        if(this.f_chknum(this.CityID) > 0 && this.f_chknum(this.AreaID.length) == 0){
            this.searchValue = '';
            let self = this;

            this.AreaList = this.AreaListForFilter.filter(item => {
                return item.City_ID == this.CityID;
            });
            setTimeout(() => {
                // console.log("=====2>", this.LastSelectedAreaId);
                this.customerList = this.customerList1.filter(item => {
                    return self.f_chknum(item.Customer_CityID) == this.CityID;
                });
                //  console.log("=====2>", this.customerList);
                setTimeout(() => {
                    this.gridApiCust.setRowData(this.customerList);
                    this.gridApiCust.onFilterChanged();
                    $('#filter-text-box').focus();
                }, 200);
                this.CustomerCityID.emit(this.f_chknum(this.CityID));
            }, 100);
        }
        
        if(this.f_chknum(this.CityID) > 0 && this.f_chknum(this.AreaID.length) > 0){
            this.AreaList = this.AreaListForFilter.filter(item => {
                return item.City_ID == this.CityID;
            });

            setTimeout(() => {
                // console.log("=====3>", this.LastSelectedAreaId);
                if(this.LastSelectedAreaId.length > 0 && this.f_chknum(this.OLDLastSelectedCityId) == this.f_chknum(this.CityID)){
                    this.AreaID = this.LastSelectedAreaId;
                }

                this.searchValue = '';
                let self = this;
                
                if(this.f_chknum(this.AreaID.length) > 0){
                    for(let i = 0; this.AreaID.length > i; i++){
                        let custlist = (this.customerList1.filter(item => {
                            return self.f_chknum(item.Customer_CityID) == this.CityID && self.f_chknum(item.Customer_AreaID) == this.AreaID[i];
                        }));
        
                        this.customerList.push(...custlist);
                    }
                }else{
                    this.customerList = this.customerList1.filter(item => {
                        return item.Customer_CityID == this.CityID;
                    });
                }
                //  console.log("=====3>", this.customerList);
                setTimeout(() => {
                    this.gridApiCust.setRowData(this.customerList);
                    this.gridApiCust.onFilterChanged();
                    $('#filter-text-box').focus();
                }, 200);
                this.CustomerCityID.emit(this.f_chknum(this.CityID));
                this.CustomerAreadID.emit(this.AreaID);
            }, 100);
        }
        
        if(this.f_chknum(this.CityID) == 0 && this.f_chknum(this.AreaID.length) == 0){
            this.searchValue = '';
            this.AreaList = this.AreaListForFilter;
            setTimeout(() => {
                this.customerList =  this.customerList1;
                //  console.log("=====4>", this.customerList);
                setTimeout(() => {
                    this.gridApiCust.setRowData(this.customerList);
                    this.gridApiCust.onFilterChanged();
                    $('#filter-text-box').focus();
                }, 200);
                this.CustomerCityID.emit(this.f_chknum(this.CityID));
                this.CustomerAreadID.emit(this.AreaID);
            }, 100);
        }
        /* else{
            this.searchValue = '';
            this.customerList =  this.customerList1;
            // console.log("=====4>", this.customerList);
            setTimeout(() => {
                this.gridApiCust.setRowData(this.customerList);
                this.gridApiCust.onFilterChanged();
                $('#filter-text-box').focus();
            }, 200);
            this.CustomerCityID.emit(this.f_chknum(this.CityID));
            this.CustomerAreadID.emit(this.AreaID);
        } */

        // this.customerList = this.customerList1.filter ;
        /* if(this.f_chknum(this.CityID) == 0 && this.f_chknum(this.AreaID) > 0){
            this.searchValue = '';
            this.customerList = this.customerList1.filter(item => {
                return item.Customer_AreaID == this.AreaID;
            });
            // console.log("=====1>", this.customerList);
            setTimeout(() => {
                this.gridApiCust.setRowData(this.customerList);
                this.gridApiCust.onFilterChanged();
                $('#filter-text-box').focus();
            }, 200);
            this.CustomerAreadID.emit(this.f_chknum(this.AreaID));
        }
        
        if(this.f_chknum(this.CityID) > 0 && this.f_chknum(this.AreaID) == 0){
            this.searchValue = '';
            this.customerList = this.customerList1.filter(item => {
                return item.Customer_CityID == this.CityID;
            });
            // console.log("=====2>", this.customerList);
            setTimeout(() => {
                this.gridApiCust.setRowData(this.customerList);
                this.gridApiCust.onFilterChanged();
                $('#filter-text-box').focus();
            }, 200);
            this.CustomerCityID.emit(this.f_chknum(this.CityID));
        }

        if(this.f_chknum(this.CityID) > 0 && this.f_chknum(this.AreaID) > 0){
            this.searchValue = '';
            this.customerList = this.customerList1.filter(item => {
                return item.Customer_CityID == this.CityID && item.Customer_AreaID == this.AreaID;
            });
            // console.log("=====3>", this.customerList);
            setTimeout(() => {
                this.gridApiCust.setRowData(this.customerList);
                this.gridApiCust.onFilterChanged();
                $('#filter-text-box').focus();
            }, 200);
            this.CustomerCityID.emit(this.f_chknum(this.CityID));
            this.CustomerAreadID.emit(this.f_chknum(this.AreaID));
        }

        if(this.f_chknum(this.CityID) == 0 && this.f_chknum(this.AreaID) == 0){
            this.searchValue = '';
            this.customerList =  this.customerList1;
            // console.log("=====4>", this.customerList);
            setTimeout(() => {
                this.gridApiCust.setRowData(this.customerList);
                this.gridApiCust.onFilterChanged();
                $('#filter-text-box').focus();
            }, 200);
            this.CustomerCityID.emit(this.f_chknum(this.CityID));
            this.CustomerAreadID.emit(this.f_chknum(this.AreaID));
        } */
    }

    ResetCityArea(event){
        this.AreaID = [];
        if(event != undefined){
            this.CityID = (this.f_chknum(event.City_ID) > 0 ? this.f_chknum(event.City_ID) : null);
        }
        this.onAreachange();
    }
    
    findUnique(arr, predicate) {
        var found = {};
        arr.forEach(d => {
            found[predicate(d)] = d;
        });
        return Object.keys(found).map(key => found[key]);
    }


    customSearchFn(term: string, item: any): boolean {
        // Check if the search term matches Area_Name or Area_Code
        term = term.toLowerCase();
        return item.Area_Name.toLowerCase().indexOf(term) > -1;
      }
}

